import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import InsightTabs from "./insightTabs";

const Insight = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Insight</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Insight" }, { title: breadcrumb }]}
        />
      </div>
      <InsightTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default Insight;
